import React from 'react'
import { useLocation } from 'react-router';
import PaymentStatus from './PaymentStatus';
import { websiteUrl } from '../../constants';
import PublicPageHeader from '../PublicPageHeader';
import PublicPageFooter from '../PublicPageFooter';

export default function PaymentStatusPublic() {
    const location = useLocation();
    const pathnames = location?.pathname?.split("/").filter((x) => x);
    const planId = pathnames?.[pathnames.length - 2];
    return (
        <div className='quotationPreviewWrapper'>
            <PublicPageHeader />

            <div className="container bankPage mt-4">
                <div className="row buyProductSection">
                    <div className="col-md-8">
                        <PaymentStatus planId={planId} />
                    </div>
                </div>
            </div>
            {/* <PublicPageFooter /> */}

        </div>
    )
}
